/* Leaf trade finder (2026-09-29): filter, sort, stock thresholds, "I need N units", planter fit, quick order. */
(function () {
  const root = document.querySelector('.lw-f');
  if (!root) return;
  const body = root.querySelector('.lw-f__body');
  const countEl = root.querySelector('.lw-f__count');
  const q = root.querySelector('.lw-f__q');
  const need = root.querySelector('.lw-f__needq');
  const state = { min: +root.dataset.minstock || 0, sort: null, dir: -1 };
  const rows = () => Array.from(body.querySelectorAll('.lw-f__row'));

  // load remaining pages (collections over 250 products) via the Section Rendering API
  const more = root.querySelector('.lw-f__more');
  const pages = +(more && more.dataset.pages) || 1;
  const sectionId = root.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-', '');
  async function loadRest() {
    for (let p = 2; p <= pages && sectionId; p++) {
      more.textContent = 'Loading more products…';
      try {
        const url = new URL(location.href); url.searchParams.set('section_id', sectionId); url.searchParams.set('page', p);
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.lw-f__row').forEach((r) => body.appendChild(r));
      } catch (e) { more.textContent = 'Some products could not be loaded. Refresh to try again.'; return; }
    }
    if (more) more.textContent = '';
    buildOptions(); apply();
  }

  function buildOptions() {
    root.querySelectorAll('.lw-f__sel[data-f="kind"],.lw-f__sel[data-f="colour"]').forEach((sel) => {
      const key = sel.dataset.f, cur = sel.value;
      const vals = [...new Set(rows().map((r) => r.dataset[key]).filter(Boolean))].sort();
      sel.length = 1; vals.forEach((v) => sel.add(new Option(v, v)));
      sel.value = cur; sel.hidden = vals.length < 2;
    });
  }

  function apply() {
    const term = (q.value || '').toLowerCase().trim();
    const kind = root.querySelector('[data-f="kind"]').value;
    const colour = root.querySelector('[data-f="colour"]').value;
    const band = root.querySelector('[data-f="hband"]').value;
    const flags = Array.from(root.querySelectorAll('[data-flag]:checked')).map((c) => c.dataset.flag);
    const n = +need.value || 0;
    const [lo, hi] = band ? band.split('-').map(Number) : [0, 1e9];
    let shown = 0, short = 0, units = 0;
    rows().forEach((r) => {
      const d = r.dataset, stock = +d.stock, h = +d.h;
      const ok = (!term || (d.name + ' ' + d.sku).toLowerCase().includes(term)) && (!kind || d.kind === kind) && (!colour || d.colour === colour)
        && (!band || (h >= lo && h <= hi)) && flags.every((f) => d[f] === '1') && stock >= state.min;
      r.hidden = !ok;
      r.classList.toggle('lw-f__row--short', ok && n > 0 && stock < n);
      if (ok) { shown++; units += stock; if (n > 0 && stock < n) short++; }
    });
    countEl.textContent = `${shown} line${shown === 1 ? '' : 's'} shown · ${units.toLocaleString()} units in stock across them` + (n ? ` · ${shown - short} can supply ${n}+ units on their own${short ? `, ${short} cannot (dimmed)` : ''}` : '');
  }

  function sortBy(key) {
    state.dir = state.sort === key ? -state.dir : (key === 'name' ? 1 : -1); state.sort = key;
    const val = (r) => key === 'name' ? r.dataset.name.toLowerCase() : +r.dataset[key] || 0;
    rows().sort((a, b) => (val(a) > val(b) ? 1 : val(a) < val(b) ? -1 : 0) * state.dir).forEach((r) => body.appendChild(r));
    root.querySelectorAll('[data-sort]').forEach((b) => b.closest('th').setAttribute('aria-sort', b.dataset.sort === key ? (state.dir > 0 ? 'ascending' : 'descending') : 'none'));
  }

  root.addEventListener('input', (e) => { if (e.target.matches('.lw-f__q,.lw-f__needq,.lw-f__sel,[data-flag]')) apply(); });
  root.addEventListener('change', (e) => { if (e.target.matches('.lw-f__sel,[data-flag]')) apply(); });
  root.querySelectorAll('.lw-f__chip').forEach((b) => b.addEventListener('click', () => {
    state.min = +b.dataset.min;
    root.querySelectorAll('.lw-f__chip').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    apply();
  }));
  root.querySelectorAll('[data-sort]').forEach((b) => b.addEventListener('click', () => sortBy(b.dataset.sort)));
  if (state.min) root.querySelectorAll('.lw-f__chip').forEach((x) => x.setAttribute('aria-pressed', +x.dataset.min === state.min ? 'true' : 'false'));

  // quick order: add every row with a quantity in one request
  const addBtn = root.querySelector('.lw-f__add'), msg = root.querySelector('.lw-f__msg');
  if (addBtn) addBtn.addEventListener('click', async () => {
    const items = Array.from(root.querySelectorAll('.lw-f__qin')).filter((i) => +i.value > 0).map((i) => ({ id: +i.dataset.variant, quantity: +i.value }));
    if (!items.length) { msg.textContent = 'Enter a quantity on at least one line.'; return; }
    addBtn.disabled = true; msg.textContent = 'Adding…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      const j = await r.json();
      if (!r.ok) throw new Error(j.description || 'Could not add to order');
      msg.innerHTML = `Added ${items.length} line${items.length > 1 ? 's' : ''}. <a href="/cart">View order</a>`;
      root.querySelectorAll('.lw-f__qin').forEach((i) => (i.value = 0));
    } catch (e) { msg.textContent = e.message + '. Check quantities against stock.'; }
    addBtn.disabled = false;
  });

  // planter fit tool
  const fitD = document.getElementById('lw-fit-d'), fitH = document.getElementById('lw-fit-h'), fitOut = document.getElementById('lw-fit-out');
  if (fitD && fitOut) {
    const params = new URLSearchParams(location.search);
    if (params.get('pot')) fitD.value = params.get('pot');
    if (params.get('h')) fitH.value = params.get('h');
    const esc = (s) => s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const fit = () => {
      const d = +fitD.value, h = +fitH.value || 0;
      if (!d) { fitOut.innerHTML = ''; return; }
      const res = [], check = [];
      rows().forEach((r) => {
        const o = +r.dataset.open, dep = +r.dataset.depth, w = +r.dataset.w, ph = +r.dataset.h;
        const name = r.querySelector('.lw-f__title').textContent, url = r.querySelector('a').getAttribute('href'), stock = +r.dataset.stock;
        if (o) {
          const gap = o - d;
          if (gap >= 1 && (!h || !dep || dep >= h - 2)) res.push({ name, url, stock, label: gap <= 3 ? 'Snug' : gap <= 6 ? 'Good' : 'Roomy', txt: `opening ${o}cm${dep ? `, inner depth ${dep}cm` : ''}` });
        } else if (w >= d + 3 && (!h || ph >= h - 4)) check.push({ name, url, stock, txt: `outer ${w} × ${ph}cm, opening not yet measured` });
      });
      const li = (x, l) => `<li><a href="${esc(x.url)}">${esc(x.name)}</a> <span class="lw-f__tag">${l || 'Check'}</span> <span class="lw-f__muted">${esc(x.txt)} · ${x.stock > 0 ? x.stock + ' in stock' : 'out of stock'}</span></li>`;
      fitOut.innerHTML = `<h3>${res.length} measured planter${res.length === 1 ? '' : 's'} fit a ${d}cm pot</h3><ul>${res.sort((a, b) => b.stock - a.stock).map((x) => li(x, x.label)).join('') || '<li>No measured planter fits yet.</li>'}</ul>` +
        (check.length ? `<h3>${check.length} more planters are large enough on the outside</h3><p class="lw-f__muted">Their inner opening has not been measured yet. Ask us to confirm the fit before ordering.</p><ul>${check.sort((a, b) => b.stock - a.stock).slice(0, 40).map((x) => li(x)).join('')}</ul>` : '');
    };
    fitD.addEventListener('input', fit); fitH.addEventListener('input', fit);
    root.addEventListener('lw:loaded', fit);
    setTimeout(fit, 0);
  }

  buildOptions(); apply();
  if (pages > 1) loadRest().then(() => root.dispatchEvent(new Event('lw:loaded')));
})();
